// import { Injectable } from '@angular/core';
import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Auth2Service } from 'src/app/tabms/services/Auth/auth2Service.service';

// @Injectable({ providedIn: 'root' })
// export class AuthGuard implements CanActivate {
//   userId;

//   constructor(private router: Router,  private auth2Service: Auth2Service) {}

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

//     let claims = JSON.parse((sessionStorage.getItem('id_token_claims_obj')));
//     if (claims) {
//       this.userId = claims['sub'];
//     }

//     if (this.userId) {
//       // logged in so return true
//       return true;
//     }

//     // not logged in so redirect to login page with the return url
//     //this.router.navigate(['/authentication-1/login'], { queryParams: { returnUrl: state.url } });
//     this.auth2Service.login();
//     return true;
//   }
// }

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const auth2Service = inject(Auth2Service);

  const claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj') || '{}');
  const userId = claims['sub'];
  // debugger;
  if (userId) {
    // logged in so return true
    return true;
  }

  // not logged in so redirect to login page with the return url
  auth2Service.login();
  return false;
};
